import {getClientTokenData} from "../App";
import {getWithExpiry} from "../pages/home/HomeFashionTwo";

export const redirectionHomeVoucher = (retailer, origin, voucher, retailerName) => {
    let retailerURL = retailer.url
    if (retailer){
        if (retailer.name) {
            switch (retailer.retailerName) {
                case "KellerSports":
                    window.open(retailerURL, '_blank')
                case "Polar":
                    window.open(retailerURL, '_blank')
                case "sportShoes":
                    window.open(retailerURL, "_blank")
                default:
                    window.open('https://app.therunningcollective.'+origin+'/redirection-with-voucher?voucher='+voucher.name+"&retailerName="+decodeURI(retailerName)+"&redirectionURL="+ decodeURI(retailerURL), '_blank')
            }
        }
    } else {
        window.open('https://app.therunningcollective.'+origin+'/redirection-with-voucher?voucher='+voucher.name+"&retailerName="+decodeURI(retailerName)+"&redirectionURL="+ decodeURI(retailerURL), '_blank')
    }
}

export function buildRedirectingLinkByUserID(retailer, origin) {
    if (!origin || origin == ""){
        origin = "fr"
    }


    let token = getClientTokenData()
    let source = getWithExpiry("trc-source")
    if(!source) {
        source = "website-"+origin
    }

    if (retailer.retailerName && token && source) {
        switch (retailer.retailerName) {
            case "365Rider":
                let url = new URL(retailer.url);
                let params = new URLSearchParams(url.search);
                let p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "adidas":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "alltricks":
                return retailer.url+"&effi_id2="+token.id + "_" + source
            case "andros":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "asics":
                return insert(retailer.url, 37, "/pubref:"+token.id + "_" + source)
            case "compressport":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "darty":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "decathlon":
                return retailer.url+"&u1="+token.id + "_" + source
            case "deporvillage":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "directRunning":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "eafit":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "ekosport":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "enduranceStore":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "fitadium":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "fitness-boutique":
                return retailer.url+"&argsite="+token.id + "_" + source
            case "fnac":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "foot-store":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "galerieLafayette":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hardloop":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hokaOneOne":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "i-Run":
                return retailer.url+"&argsite="+token.id + "_" + source                
            case "intersport":
                return retailer.url+"&argsite="+token.id + "_" + source  
            case "jdSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "lepape":
                return retailer.url+"?sid="+token.id + "_" + source 
            case "maxiSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "newBalance":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "nike":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "on":
                return insert(retailer.url, 58, "&clickref="+token.id + "_" + source)
            case "passionRunning":
                return retailer.url+"&aev="+token.id + "_" + source 
            case "polar":
                return insert(retailer.url, 58, "&clickref="+token.id + "_" + source)
            case "PriveByZalando":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "proDirect":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "PUMA":
                return retailer.url+"?sid="+token.id + "_" + source 
            case "punch-power":
                return retailer.url+"&argsite="+token.id + "_" + source  
            case "Quatorze":
                return retailer.url+"&aev="+token.id + "_" + source 
            case "runnerInn":
                return retailer.url+"&smc1="+token.id + "_" + source 
            case "saucony":
                return insert(retailer.url, 58, "&clickref="+token.id + "_" + source)
            case "sportIsGood":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "sportsShoes":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id + "_" + source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "stc-nutrition	":
                return retailer.url+"&argsite="+token.id + "_" + source  
            case "tontonOutdoor":
                return retailer.url + "&a_cha="+token.id + "_" + source
            case "top4running":
                return retailer.url + "&a_cha="+token.id + "_" + source
        }
    } else if (retailer.retailerName && token) {
        switch (retailer.retailerName) {
            case "365Rider":
                let url = new URL(retailer.url);
                let params = new URLSearchParams(url.search);
                let p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "adidas":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "alltricks":
                return retailer.url+"&effi_id2="+token.id
            case "andros":
                return retailer.url+"&argsite="+token.id
            case "asics":
                return insert(retailer.url, 37, "/pubref:"+token.id)
            case "compressport":
                return retailer.url+"&argsite="+token.id
            case "darty":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "decathlon":
                return retailer.url+"&u1="+token.id
            case "deporvillage":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "directRunning":
                return retailer.url+"&argsite="+token.id
            case "eafit":
                return retailer.url+"&argsite="+token.id
            case "ekosport":
                return retailer.url+"&argsite="+token.id
            case "enduranceStore":
                return retailer.url+"&argsite="+token.id
            case "fitadium":
                return retailer.url+"&argsite="+token.id
            case "fitness-boutique":
                return retailer.url+"&argsite="+token.id
            case "fnac":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "foot-store":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "galerieLafayette":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hardloop":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hokaOneOne":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "i-Run":
                return retailer.url+"&argsite="+token.id                
            case "intersport":
                return retailer.url+"&argsite="+token.id  
            case "jdSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "lepape":
                return retailer.url+"?sid="+token.id 
            case "maxiSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "newBalance":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "nike":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "on":
                return insert(retailer.url, 58, "&clickref="+token.id)
            case "passionRunning":
                return retailer.url+"&aev="+token.id 
            case "polar":
                return insert(retailer.url, 58, "&clickref="+token.id)
            case "PriveByZalando":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "proDirect":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "PUMA":
                return retailer.url+"?sid="+token.id 
            case "punch-power":
                return retailer.url+"&argsite="+token.id  
            case "Quatorze":
                return retailer.url+"&aev="+token.id 
            case "runnerInn":
                return retailer.url+"&smc1="+token.id 
            case "saucony":
                return insert(retailer.url, 58, "&clickref="+token.id)
            case "sportIsGood":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "sportsShoes":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2", token.id)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "stc-nutrition	":
                return retailer.url+"&argsite="+token.id  
            case "tontonOutdoor":
                return retailer.url + "&a_cha="+token.id
            case "top4running":
                return retailer.url + "&a_cha="+token.id
        }
    } else if(source) {
        switch (retailer.retailerName) {
            case "365Rider":
                let url = new URL(retailer.url);
                let params = new URLSearchParams(url.search);
                let p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "adidas":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "alltricks":
                return retailer.url+"&effi_id2="+ source
            case "andros":
                return retailer.url+"&argsite="+ source
            case "asics":
                return insert(retailer.url, 37, "/pubref:"+ source)
            case "compressport":
                return retailer.url+"&argsite="+ source
            case "darty":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "decathlon":
                return retailer.url+"&u1="+ source
            case "deporvillage":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "directRunning":
                return retailer.url+"&argsite="+ source
            case "eafit":
                return retailer.url+"&argsite="+ source
            case "ekosport":
                return retailer.url+"&argsite="+ source
            case "enduranceStore":
                return retailer.url+"&argsite="+ source
            case "fitadium":
                return retailer.url+"&argsite="+ source
            case "fitness-boutique":
                return retailer.url+"&argsite="+ source
            case "fnac":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "foot-store":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "galerieLafayette":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hardloop":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "hokaOneOne":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "i-Run":
                return retailer.url+"&argsite="+ source                
            case "intersport":
                return retailer.url+"&argsite="+ source  
            case "jdSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "lepape":
                return retailer.url+"?sid="+ source 
            case "maxiSports":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "newBalance":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "nike":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "on":
                return insert(retailer.url, 58, "&clickref="+ source)
            case "passionRunning":
                return retailer.url+"&aev="+ source 
            case "polar":
                return insert(retailer.url, 58, "&clickref="+ source)
            case "PriveByZalando":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "proDirect":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "PUMA":
                return retailer.url+"?sid="+ source 
            case "punch-power":
                return retailer.url+"&argsite="+ source  
            case "Quatorze":
                return retailer.url+"&aev="+ source 
            case "runnerInn":
                return retailer.url+"&smc1="+ source 
            case "saucony":
                return insert(retailer.url, 58, "&clickref="+ source)
            case "sportIsGood":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "sportsShoes":
                url = new URL(retailer.url);
                params = new URLSearchParams(url.search);
                p = params.get("p")
                params.delete("p");
                params.set("clickref2",  source)
                params.set("p", p)
                return url.origin + url.pathname+"?"+params.toString()
            case "stc-nutrition	":
                return retailer.url+"&argsite="+ source  
            case "tontonOutdoor":
                return retailer.url + "&a_cha="+ source
            case "top4running":
                return retailer.url + "&a_cha="+ source
        }
    }
    return retailer.url
}


function insert(str, index, value) {
    return str.substr(0, index) + value + str.substr(index);
}